import { render, staticRenderFns } from "./Lembrar.vue?vue&type=template&id=5e5e0b98&scoped=true"
import script from "./Lembrar.vue?vue&type=script&lang=js"
export * from "./Lembrar.vue?vue&type=script&lang=js"
import style0 from "./Lembrar.vue?vue&type=style&index=0&id=5e5e0b98&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e5e0b98",
  null
  
)

export default component.exports